import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BookOfShadowsGameConfig} from "../../../BookOfShadowsGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {BookOfShadows} from "../../../BookOfShadows";
import {TimelineMax, TweenLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class GameTutorialView extends BaseView {
    private _rowTutorial: PIXI.Container;
    private _lockTutorial: PIXI.Container;

    private _lockArrow: PIXI.Sprite;
    private _lockText: PIXI.Text;
    private _lockArrowTL: TimelineMax;

    /**
     * @description To stop row tutorial.
     */
    public stopRowTutorial(): void {
        if (this._rowTutorial.alpha > 0) {
            TweenLite.to(this._rowTutorial, 0.2, {
                alpha: 0, onComplete: () => {
                    this._rowTutorial.visible = false;
                }
            });
        }
    }

    /**
     * @description To stop lock tutorial.
     */
    public stopLockTutorial(): void {
        if (this._lockTutorial.alpha > 0) {
            TweenLite.to(this._lockTutorial, 0.2, {
                alpha: 0, onComplete: () => {
                    this._lockTutorial.visible = false;

                    this._lockArrowTL.pause();
                    this._lockArrowTL.kill();
                }
            });
        }
    }

    /**
     * @description To play row tutorial.
     */
    public playRowTutorial(): void {
        this._rowTutorial.visible = true;
        this._rowTutorial.alpha = 0;

        TweenLite.to(this._rowTutorial, 0.2, {alpha: 1});
    }

    /**
     * @description To play lock tutorial.
     */
    public playLockTutorial(): void {
        this._lockTutorial.visible = true;
        this._lockTutorial.alpha = 0;

        TweenLite.to(this._lockTutorial, 0.2, {alpha: 1});
        this._lockArrowTL.restart();
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();
        StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.GAME_TUTORIAL.name).addChild(this);
        this._rowTutorial = new PIXI.Container();
        this._lockTutorial = new PIXI.Container();
        this._rowTutorial.visible = false;
        this._lockTutorial.visible = false;

        this.createRowTutorial();
        this.createLockTutorial();

        this._lockTutorial.pivot.set(this._lockTutorial.width / 2, this._lockTutorial.height / 2);

        this.addChild(this._rowTutorial, this._lockTutorial);

        this.createArrowTl();
    }

    /**
     * @inheritDoc
     * @param resizeData
     */
    protected onResize(resizeData: IResizeData) {
        super.onResize && super.onResize(resizeData);

        if (NolimitApplication.isLandscape) {
            this._lockTutorial.position.set(200, 560);
            this._lockText.y = 30;
            this._lockArrow.rotation = (6.28 / 4);
        } else {
            this._lockTutorial.position.set(200, 140);
            this._lockArrow.rotation = (6.28 * (3 / 4));
            this._lockText.y = 120;
        }
    }

    /**
     * @description To create row tutorial items.
     */
    private createRowTutorial(): void {
        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
                fill: "#fff",
                fontFamily: "Open Sans",
                fontSize: 26,
                fontStyle: FontStyle.NORMAL,
                fontWeight: FontWeight.EXTRA_BOLD
            }),
            textStr: string = BookOfShadows.api.translations.translate("Tap/Click for Shadow Rows"),
            text: PIXI.Text = new PIXI.Text(textStr, textStyle);

        text.anchor.set(0.5);
        text.position.set(BookOfShadowsGameConfig.instance.GAME_HEIGHT / 2, (3 * BookOfShadowsGameConfig.instance.SYMBOL_HEIGHT) - 60);
        Helper.shrinkTextWidth(textStr, text, BookOfShadowsGameConfig.instance.REEL_AREA_WIDTH);

        this._rowTutorial.addChild(text);
    }

    /**
     * @description To create lock tutorial items.
     */
    private createLockTutorial(): void {
        const box: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("textBox")[0]),
            textStyle: PIXI.TextStyle = new PIXI.TextStyle({
                fill: "#fff",
                fontFamily: "Open Sans",
                fontSize: 26,
                fontStyle: FontStyle.NORMAL,
                fontWeight: FontWeight.EXTRA_BOLD
            }),
            text: PIXI.Text = new PIXI.Text(BookOfShadows.api.translations.translate("Lucky Locks"), textStyle),
            arrow: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("whiteArrow")[0]);

        text.anchor.set(0.5);
        text.x = box.width / 2;

        arrow.anchor.set(0.5);
        arrow.position.set((box.width / 2), 80);

        this._lockTutorial.addChild(box, text, arrow);

        this._lockArrow = arrow;
        this._lockText = text;
    }

    /**
     * @description To create arrow timeline.
     */
    private createArrowTl(): void {
        const duration: number = 0.3;

        this._lockArrowTL = new TimelineMax({
            paused: true,
            repeat: 8,
            repeatDelay: 0
        });

        this._lockArrowTL.to(this._lockArrow, duration, {y: this._lockArrow.y - 30})
            .to(this._lockArrow, duration, {y: this._lockArrow.y + 10});
    }
}